import { conf, DEMO_MODE } from "../config/config"

export { DEMO_MODE }

export const AUTH_TOKEN = 'admin-auth-token'
export const SESSION_TOKEN = 'admin-session-token'
export const USER_UUID = 'admin-user-uuid'
export const DEMO_TOKEN  = conf['token']

export const ACTIVITY_LOG = 'admin-activity-log'
export const TRANSACTION_LOG = 'admin-transaction-log'
export const ENTITY_COUNTS = 'admin-entity-counts'
